/* eslint-disable global-require */
module.exports = ['tour.accountlang.section.title1', 'tour.accountlang.section.content1', 'tour.accountlang.section.button1'];
